import {
  DELETE_ORDERBOOK_MODIFY, DELETE_ORDERBOOK_MODIFY_ALL,
  DELETE_ORDERBOOK_REMOVE_SELECT,
  DELETE_ORDERBOOK_TMP_MODIFY, DELETE_ORDERBOOK_TMP_MODIFY_ALL, GET_BOOK_DELIVERY_LIST,
  GET_BOOKLIST,
  GET_ORDERBOOK_AUTO_SELECT,
  GET_ORDERBOOK_BUYERINFO,
  GET_ORDERBOOK_CART,
  GET_ORDERBOOK_CART_ALL,
  GET_ORDERBOOK_CHANGE,
  GET_ORDERBOOK_CURRENT,
  GET_ORDERBOOK_ETC_CART,
  GET_ORDERBOOK_LIMIT_CHECK,
  GET_ORDERBOOK_MEMBER_CHECK,
  GET_ORDERBOOK_MEMBER_ORDER_LIST,
  GET_ORDERBOOK_MONITERING_BOOK_LIST,
  GET_ORDERBOOK_MONITERING_LIST,
  GET_ORDERBOOK_MONITERING_MEMBER_LIST,
  GET_ORDERBOOK_MONITORING_LIST,
  GET_ORDERBOOK_ORDER_CANCEL_ITEM,
  GET_ORDERBOOK_ORDER_CANCEL_LIST,
  GET_ORDERBOOK_ORDER_DETAIL,
  GET_ORDERBOOK_ORDER_LIST,
  GET_ORDERBOOK_ORDER_MODIFY_ITEM,
  GET_ORDERBOOK_ORDER_MODIFY_LIST,
  GET_ORDERBOOK_PAYMENT_DETAIL,
  GET_ORDERBOOK_SELECT,
  GET_ORDERBOOK_START_ORDER,
  GET_ORDERBOOK_TABLE,
  GET_ORDERBOOK_TABLE_OPTION,
  GET_ORDERBOOK_TMP_CURRENT,
  GET_ORDERBOOK_TMP_ORDER_LIST,
  GET_TMP_ORDER_NO,
  POST_ORDER_NO,
  POST_ORDERBOOK_AUTO_SELECT_ALL,
  POST_ORDERBOOK_CART, POST_ORDERBOOK_CART_ALL, POST_ORDERBOOK_CART_ETC_ALL, POST_ORDERBOOK_CURRENT_ALL,
  POST_ORDERBOOK_EXCHANGE,
  POST_ORDERBOOK_MEMBER_MEMO_LIST,
  POST_ORDERBOOK_MODIFY, POST_ORDERBOOK_MODIFY_ALL,
  POST_ORDERBOOK_MONITERING,
  POST_ORDERBOOK_MONITERING_ALL,
  POST_ORDERBOOK_MONITERING_BOOK_ALL_LIST,
  POST_ORDERBOOK_MONITORING_MEMO,
  POST_ORDERBOOK_MONITORING_STATUS,
  POST_ORDERBOOK_PAYMENT,
  POST_ORDERBOOK_REFUND,
  POST_ORDERBOOK_SAVE,
  POST_ORDERBOOK_SAVE_ETC,
  POST_ORDERBOOK_SAVE_SELECT, POST_ORDERBOOK_TMP_CURRENT_ALL,
  POST_ORDERBOOK_TMP_MODIFY, POST_ORDERBOOK_TMP_MODIFY_ALL,
  PUT_ORDERBOOK_CANCEL,
  PUT_ORDERBOOK_ORDER_GROUP,
  PUT_ORDERBOOK_ORDER_GROUP_CANCEL,
  PUT_ORDERBOOK_ORDER_INFO,
  PUT_ORDERBOOK_STATUS,
  GET_BOOK_DELIVERY_PDF_LIST,
  POST_ORDERBOOK_PENDING_PAYMENT,
  GET_NEWSLETTER_PERIOD
} from 'api/endpoint';
import client from '../axios';

// 교육원 주문 목록
export const getOrderBookAPI = (data) => {
  let url;
  if (data) url = GET_ORDERBOOK_ORDER_LIST.concat(data);
  else url = GET_ORDERBOOK_ORDER_LIST;
  return client.get(url);
};

// 교육원 주문 상세
export const getOrderBookDetailAPI = (order_idx, params) => {
  return client.get(GET_ORDERBOOK_ORDER_DETAIL.replace(':order_idx', order_idx), {params});
};

export const putOrderBookInfoAPI = (order_idx, params) => {
  return client.put(PUT_ORDERBOOK_ORDER_INFO.replace(':order_idx', order_idx), params);
};

// 주문상세- 결제방식,주문상태 수정
export const putOrderBookGroupAPI = (params) => {
  console.log(params);
  return client.put(PUT_ORDERBOOK_ORDER_GROUP, params);
};

// 주문상세- 특정회원 주문취소
export const putOrderBookGroupCancelAPI = (params) => {
  console.log(params);
  return client.put(PUT_ORDERBOOK_ORDER_GROUP_CANCEL, params);
};

// 교육원 주문 환불 목록
export const getOrderBookCancelAPI = (data) => {
  const url = GET_ORDERBOOK_ORDER_CANCEL_LIST.concat(data);
  console.log(url);
  return client.get(url);
};

// 교육원 주문 회원 환불 상세 리스트
export const getOrderBookCancelItemAPI = (data) => {
  const url = GET_ORDERBOOK_ORDER_CANCEL_ITEM.concat(data);
  console.log(url);
  return client.get(url);
};

// 교육원 주문 수정 목록
export const getOrderBookModifyAPI = (data) => {
  const url = GET_ORDERBOOK_ORDER_MODIFY_LIST.concat(data);
  console.log(url);
  return client.get(url);
};

// 교육원 주문 수정 상세 목록
export const getOrderBookModifyItemAPI = (data) => {
  const url = GET_ORDERBOOK_ORDER_MODIFY_ITEM.concat(data);
  console.log(url);
  return client.get(url);
};

// 교육원 교재 주문제한 확인
export const getOrderLimitCheckAPI = () => {
  return client.get(GET_ORDERBOOK_LIMIT_CHECK);
};

// 교육원 교재 주문 화면
export const getStartOrderAPI = (school_idx, teacher_idx) => {
  return client.get(GET_ORDERBOOK_START_ORDER.replace(':school_idx', school_idx).replace(':teacher_idx', teacher_idx));
};

// 교육원 교재주문 가능한 회원 확인
export const getOrderMemberCheckAPI = (new_order_yn, school_idx, teacher_idx) => {
  return client.get(GET_ORDERBOOK_MEMBER_CHECK.replace(':new_order_yn', new_order_yn).replace(':school_idx', school_idx).replace(':teacher_idx', teacher_idx));
};

// 교재 주문 신규/기존 리스트
export const getOrderTableAPI = (new_order_yn, school_idx, teacher_idx, order_no) => {
  return client.get(GET_ORDERBOOK_TABLE.replace(':new_order_yn', new_order_yn).replace(':school_idx', school_idx).replace(':teacher_idx', teacher_idx).replace(':order_no', order_no));
};
// 교재 주문 신규/기존 리스트 옵션값
export const getOrderTableOptionAPI = (new_order_yn, school_idx, teacher_idx) => {
  return client.get(GET_ORDERBOOK_TABLE_OPTION.replace(':new_order_yn', new_order_yn).replace(':school_idx', school_idx).replace(':teacher_idx', teacher_idx));
};

// 교재 주문 회원별 주문 가능 교재 리스트
export const getOrderSelectAPI = (book_cate1_code, book_cate2_code, member_idx) => {
  return client.get(GET_ORDERBOOK_SELECT.replace(':book_cate1_code', book_cate1_code).replace(':book_cate2_code', book_cate2_code).replace(':member_idx', member_idx));
};

// 교육원 교재 주문 회원별 자동 교재 목록
export const getOrderAutoSelectAPI = (book_cate1_code, book_cate2_code, member_idx) => {
  return client.get(GET_ORDERBOOK_AUTO_SELECT.replace(':book_cate1_code', book_cate1_code).replace(':book_cate2_code', book_cate2_code).replace(':member_idx', member_idx));
};
// 교육원 교재 주문 회원전체 자동 교재 목록
export const postOrderAutoSelectAllAPI = (data) => {
  return client.post(POST_ORDERBOOK_AUTO_SELECT_ALL, data);
};

// 교육원 교재 주문 회원별 선택 교재 저장
export const postOrderSelectAPI = (book_cate1_code, book_cate2_code, newOrderYn, member_idx, data) => {
  return client.post(POST_ORDERBOOK_SAVE_SELECT.replace(':book_cate1_code', book_cate1_code).replace(':book_cate2_code', book_cate2_code).replace(':new_yn', newOrderYn).replace(':member_idx', member_idx), data);
};

// 교육원 교재 주문 회원별 선택 교재 삭제
export const deleteOrderRemoveSelectAPI = (tmp_order_no, book_cate2_code, member_idx) => {
  return client.post(DELETE_ORDERBOOK_REMOVE_SELECT.replace(':tmp_order_no', tmp_order_no).replace(':book_cate2_code', book_cate2_code).replace(':member_idx', member_idx));
};

// 교육원 교재 임시 주문 회원별 현재 선택 교재 목록
export const getOrderTmpCurrentAPI = (tmp_order_no, book_cate1_code, book_cate2_code, member_idx) => {
  return client.get(GET_ORDERBOOK_TMP_CURRENT.replace(':tmp_order_no', tmp_order_no).replace(':book_cate1_code', book_cate1_code).replace(':book_cate2_code', book_cate2_code).replace(':member_idx', member_idx));
};

// 교육원 교재 주문 회원별 현재 선택 교재 목록
export const getOrderCurrentAPI = (order_no, book_cate1_code, book_cate2_code, member_idx) => {
  return client.get(GET_ORDERBOOK_CURRENT.replace(':order_no', order_no).replace(':book_cate1_code', book_cate1_code).replace(':book_cate2_code', book_cate2_code).replace(':member_idx', member_idx));
};

// 교육원 교재 임시 주문 회원별 현재 선택 교재 목록
export const getOrderTmpCurrentAllAPI = (tmp_order_no, data) => {
  return client.post(POST_ORDERBOOK_TMP_CURRENT_ALL.replace(':tmp_order_no', tmp_order_no), data);
};

// 교육원 교재 주문 회원별 현재 선택 교재 목록
export const getOrderCurrentAllAPI = (order_no, data) => {
  return client.post(POST_ORDERBOOK_CURRENT_ALL.replace(':order_no', order_no), data);
};

// 교육원 교재 주문 기타/물품 저장
export const postOrderEtcAPI = (data) => {
  return client.post(POST_ORDERBOOK_SAVE_ETC, data);
};
// 교육원 교재 주문 기타/물품 저장 신규
export const postOrderSaveAPI = (data) => {
  return client.post(POST_ORDERBOOK_SAVE, data);
};

// 교육원 교재 주문 교재 임시저장(장바구니)
export const postOrderBookCartAPI = (data) => {
  return client.post(POST_ORDERBOOK_CART, data);
};

// 교육원 교재 주문 교재 임시저장(장바구니) 신규
export const postOrderBookCartAllAPI = (data) => {
  return client.post(POST_ORDERBOOK_CART_ALL, data);
};

// 교육원 교재 주문 기타/물품 임시저장 신규
export const postOrderEtcCartAllAPI = (data) => {
  return client.post(POST_ORDERBOOK_CART_ETC_ALL, data);
};

// 교육원 교재 주문 교재 불러오기
export const getOrderBookCartAPI = (book_cate1_code, book_cate2_code, member_idx, school_idx, teacher_idx, new_yn, yyyy, mm) => {
  return client.get(GET_ORDERBOOK_CART.replace(':book_cate1_code', book_cate1_code).replace(':book_cate2_code', book_cate2_code).replace(':member_idx', member_idx).replace(':school_idx', school_idx).replace(':teacher_idx', teacher_idx).replace(':new_yn', new_yn).replace(':yyyy', yyyy).replace(':mm', mm));
};
// 교육원 교재 주문 교재 불러오기 신규
export const getOrderBookCartAllAPI = (school_idx, teacher_idx, new_yn, yyyy, mm, data) => {
  return client.post(GET_ORDERBOOK_CART_ALL.replace(':school_idx', school_idx).replace(':teacher_idx', teacher_idx).replace(':new_yn', new_yn).replace(':yyyy', yyyy).replace(':mm', mm), data);
};

// 교육원 교재 주문 기타/물품 불러오기
export const getOrderBookEtcCartAPI = (school_idx, teacher_idx, new_yn, yyyy, mm) => {
  return client.get(GET_ORDERBOOK_ETC_CART.replace(':school_idx', school_idx).replace(':teacher_idx', teacher_idx).replace(':new_yn', new_yn).replace(':yyyy', yyyy).replace(':mm', mm));
};

// 교육원 교재 주문 회원별 모니터링 결과
export const getOrderMoniteringMemberAPI = (order_no, tmp_order_no) => {
  return client.get(GET_ORDERBOOK_MONITERING_MEMBER_LIST.replace(':order_no', order_no).replace(':tmp_order_no', tmp_order_no));
};

// 교육원 교재 주문 회원별 모니터링 결과 교재별
export const getOrderMoniteringBookAPI = (order_no, tmp_order_no, member_idx) => {
  return client.get(GET_ORDERBOOK_MONITERING_BOOK_LIST.replace(':order_no', order_no).replace(':tmp_order_no', tmp_order_no).replace(':member_idx', member_idx));
};

// 교육원 교재 주문 회원별 모니터링 결과 교재별 전체
export const postOrderMoniteringBookAllAPI = (order_no, tmp_order_no, data) => {
  return client.post(POST_ORDERBOOK_MONITERING_BOOK_ALL_LIST.replace(':order_no', order_no).replace(':tmp_order_no', tmp_order_no), data);
};

// 교육원 교재 주문 회원별 모니터링 사유 전송
export const postOrderMoniteringAPI = (data) => {
  return client.post(POST_ORDERBOOK_MONITERING, data);
};

// 교육원 교재 주문 회원별 모니터링 사유 전송
export const postOrderMoniteringAllAPI = (data) => {
  return client.post(POST_ORDERBOOK_MONITERING_ALL, data);
};

// 교육원 교재 주문 확인
export const getTmpOrderBookAPI = (tmp_order_no) => {
  return client.get(GET_ORDERBOOK_TMP_ORDER_LIST.replace(':tmp_order_no', tmp_order_no));
};

// 교육원 교재 주문 번호 생성
export const postOrderNoAPI = (data) => {
  return client.post(POST_ORDER_NO, data);
};

// 교육원 임시주문번호 조회
export const getTmpOrderNoAPI = (order_no) => {
  return client.get(GET_TMP_ORDER_NO.replace(':order_no', order_no));
};

// 구매자(교육원) 정보
export const getOrderBookBuyerInfoAPI = (school_idx) => {
  return client.get(GET_ORDERBOOK_BUYERINFO.replace(':school_idx', school_idx));
};

// 교육원 교재 주문 결제 보류
export const postOrderBookPendingPaymentAPI = (data) => {
  return client.post(POST_ORDERBOOK_PENDING_PAYMENT, data);
};

// 교육원 교재 주문 결제
export const postOrderBookPaymentAPI = (data) => {
  return client.post(POST_ORDERBOOK_PAYMENT, data);
};

// 교육원 교재 주문 결제 상세
export const getOrderBookPaymentDetailAPI = (order_no) => {
  return client.get(GET_ORDERBOOK_PAYMENT_DETAIL.replace(':order_no', order_no));
};

// 교육원 교재 환불 요청
export const postOrderBookRefundAPI = (data) => {
  return client.post(POST_ORDERBOOK_REFUND, data);
};

// 교육원 교재 주문 취소
export const putOrderBookCancelAPI = (order_idx) => {
  return client.put(PUT_ORDERBOOK_CANCEL.replace(':order_idx', order_idx));
};

// 교재 주문 수정 리스트
export const getOrderBookChangeAPI = (params) => {
  return client.get(GET_ORDERBOOK_CHANGE, {params});
};

// 교재 주문 내역 리스트
export const getOrderBookMemberOrderAPI = (params) => {
  return client.get(GET_ORDERBOOK_MEMBER_ORDER_LIST, {params});
};

// 교재 모니터링 리스트
export const getOrderBookMonitoringAPI = (params) => {
  return client.get(GET_ORDERBOOK_MONITORING_LIST, {params});
};

//교재목록
export const getBookListAPI = (params) => {
  return client.get(GET_BOOKLIST, {params});
};

// 교육원 교재 임시 주문 수정
export const postTmpOrderBookModifyAPI = (data) => {
  return client.post(POST_ORDERBOOK_TMP_MODIFY, data);
};

// 교육원 교재 임시 주문 삭제
export const deleteTmpOrderBookModifyAPI = (data) => {
  return client.delete(DELETE_ORDERBOOK_TMP_MODIFY, {data});
};

// 교육원 교재 임시 주문 수정 신규
export const postTmpOrderBookModifyAllAPI = (data) => {
  return client.post(POST_ORDERBOOK_TMP_MODIFY_ALL, data);
};

// 교육원 교재 임시 주문 삭제 신규
export const deleteTmpOrderBookModifyAllAPI = (data) => {
  return client.delete(DELETE_ORDERBOOK_TMP_MODIFY_ALL, {data});
};

// 교육원 교재 주문 수정
export const postOrderBookModifyAPI = (data) => {
  return client.post(POST_ORDERBOOK_MODIFY, data);
};

// 교육원 교재 주문 삭제
export const deleteOrderBookModifyAPI = (data) => {
  return client.delete(DELETE_ORDERBOOK_MODIFY, {data});
};

// 교육원 교재 주문 수정 신규
export const postOrderBookModifyAllAPI = (data) => {
  return client.post(POST_ORDERBOOK_MODIFY_ALL, data);
};

// 교육원 교재 주문 삭제 신규
export const deleteOrderBookModifyAllAPI = (data) => {
  return client.delete(DELETE_ORDERBOOK_MODIFY_ALL, {data});
};

// 교육원 교재 주문 교환 요청
export const postOrderBookExchangeAPI = (data) => {
  return client.post(POST_ORDERBOOK_EXCHANGE, data);
};

// 교재주문관리 주문상태수정 (일괄수정)
export const putOrderBookStatusAPI = (data) => {
  return client.put(PUT_ORDERBOOK_STATUS, data);
}

// 교재 주문 모니터링 목록
export const getOrderBookMoniteringListAPI = (params) => {
  return client.get(GET_ORDERBOOK_MONITERING_LIST, {params});
};

// 교재 주문 모니터링(회원별 교재 주문 내역) 메모 수정
export const postOrderBookMonitoringMemoAPI = (data) => {
  return client.post(POST_ORDERBOOK_MONITORING_MEMO, data);
}

// 교재 주문 모니터링 승인여부/지사메모 수정
export const postOrderBookMonitoringStatusAPI = (data) => {
  return client.post(POST_ORDERBOOK_MONITORING_STATUS, data);
}

// 회원별 교재 주문 모니터링 메모 수정
export const postOrderBookMemberMemoAPI = (data) => {
  return client.post(POST_ORDERBOOK_MEMBER_MEMO_LIST, data);
}

// 소식지 기한 설정 여부
export const getNewsletterPeriodAPI = (params) => {
  return client.get(GET_NEWSLETTER_PERIOD, {params});
};

// 교재주문관리 엑셀 배송용 출력
export const getOrderBookDeliveryAPI = (orderIdxArr, product_fg) => {
  let queryString = '?'
  queryString += `${product_fg ? 'product_fg=1&' : ''}`
  orderIdxArr.forEach(idx => {
    queryString += `order_idx=${idx}&`
  })
  return client.get(GET_BOOK_DELIVERY_LIST + queryString);
}

//교재주문관리 PDF 배송용 출력
export const getOrderbookDeliveryPdfAPI = (orderIdxArr, product_fg) => {
  let queryString = '?'
  queryString += `${product_fg ? 'product_fg=1&' : ''}`
  orderIdxArr.forEach(idx => {
    queryString += `order_idx=${idx}&`
  })
  return client.get(GET_BOOK_DELIVERY_PDF_LIST + queryString);
}